import React from 'react'
import '../style.css'
import { FaWhatsapp } from "react-icons/fa";
import { FaRegEnvelope } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import { company } from './navbar/Navbar';

const Footer = () => {
  const year = new Date().getFullYear();

  const data = {
    explore: {
      caption: "Explore",
      body: [
        {
          title: "Home",
          link: "#",
        },
        {
          title: "Persyaratan",
          link: "#about-us",
        },
        {
          title: `J1 Internship`,
          link: "/j1-internship",
        },
        {
          title: `Study Abroad`,
          link: "/study-abroad",
        },
      ]
    },

    contact: {
      caption: "Contacts",
      body: [
        {
          name: "+62 811-3891-4770 (WA)",
          icon: <FaWhatsapp />,
          url: "https://wa.me/6281138914770"
        },
        {
          name: "info@niecindonesia.com",
          icon: <FaRegEnvelope />,
          url: "mailto:info@niecindonesia.com"
        },
        {
          name: "Facebook",
          icon: <FaFacebookF />,
          url: "https://www.facebook.com/profile.php?id=61553630410640"
        },
        {
          name: "Linkedin",
          icon: <FaLinkedinIn />,
          url: "https://www.linkedin.com/company/niec-indonesia/"
        },
        {
          name: "Instagram",
          icon: <FaInstagram />,
          url: "https://www.instagram.com/niec_indonesia/"
        },
        {
          name: "Youtube",
          icon: <FaYoutube />,
          url: "https://www.youtube.com/channel/UCA5qiOgJdfMvADpyU7Oz7fQ"
        },
      ]
    },

    office: {
      caption: "Office",
      body: [
        { city: "Denpasar Office", address: "Jl. Buluh Indah No.56, Pemecutan Kaja, Denpasar, Kota Denpasar, Bali 80111", map: "https://maps.app.goo.gl/gUN8RdMAPZrRVsK56" },
        { city: "Jakarta Branch Office", address: "Haery 1 Building (Kantor MULA) - Office & Commercial Space, Jl. Kemang Sel. Raya No.151, RT.4/RW.4 - Jakarta", map: "https://maps.app.goo.gl/bWyYhG92M3ZLRpeJ8" },
        { city: "Tangerang Branch Office", address: "Sanctuary Bintaro Co Working Space, Ruko Emerald Boulevard Bintaro, Tangerang Selatan, Banten 15227", map: "https://maps.app.goo.gl/G7cFaA3dYKbiAfcx6" },
        { city: "Bandung Branch Office", address: "Point Lab Co-working Space, Jl. Banda No.30 - Bandung", map: "https://maps.app.goo.gl/4XX7s7DvdtYHJrpg7" },
        { city: "Medan Branch Office", address: "GoWork Sinar Mas Land Plaza Jl. Pangeran Diponegoro No.18 Lt. 10 Medan Polonia - Kota Medan", map: "https://maps.app.goo.gl/rvPPF5Qdq9kBKLK78" },
        { city: "Yogyakarta Branch Office", address: "Jl. Bintaran Kidul No.36, Wirogunan, Kec. Mergangsan, Kota Yogyakarta, Daerah Istimewa Yogyakarta 55151", map: "https://maps.app.goo.gl/jwCFyxQvSNQiMj7S8" },
        { city: "Surabaya Branch Office", address: "IdeaHub Coworking Space Voza Tower, Jl. Mayjen HR. Muhammad No.31, Putat Gede, Surabaya-Jawa Timur", map: "https://maps.app.goo.gl/9cR1bZhCH9mMzYE56" },
        { city: "Makassar Branch Office", address: "Bikin Bikin Creative Hub Mall Nipah, Jl. Urip Sumoharjo No.23C Panakkukang - Kota Makassar", map: "https://maps.app.goo.gl/b4ZkZrm4sNuHQ63E8" },
      ]
    },
  }

  return (
    <section id="footer" className='footer-wrapper'>
      <footer className="container">
        <div className='row my-4 gap-3 gap-lg-0'>
          <div className='col-lg-6'>
            <a href="https://niecindonesia.com/" className="link">
              <img src={`${process.env.PUBLIC_URL}/img/logo.webp`} className="img-fluid logo-niec" />
            </a>
            <p className='pt-2'>
              Dengan pengalaman 15 tahun, kami telah memberangkatkan ribuan
              anak Indonesia kuliah di luar negeri. Bekerja sama dengan
              lebih dari 250 kampus secara langsung ke destinasi puluhan negara
            </p>
          </div>
          <div className='col-lg-3'>
            <h5>
              {data.explore.caption}
            </h5>
            <ul className='ps-0'>
              {data.explore.body.map((item, id) => (
                <li key={id}>
                  <a href={item.link}>
                    <span className='d-flex gap-3'>{item.title}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className='col-lg-3'>
            <h5>{data.contact.caption}</h5>
            <ul className='ps-0'>
              {data.contact.body.slice(0, 2).map((item, id) => (
                <li key={id}>
                  <a href={item.url}>
                    <span className='d-flex gap-2'>{item.icon}{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
            <ul className='d-flex align-items-center ps-0 social-links py-3'>
              Follow us on :
              {data.contact.body.slice(2, 6).map((item, id) => (
                <li key={id}>
                  <a href={item.url} target="_blank" rel='noopener noreferrer'>
                    <span className='d-flex'>{item.icon}</span>
                  </a>
                </li>
              ))}
            </ul>
            <div>
              <p className='mb-1'>Jelajahi Super Student</p>
              <div className="items-center">
                <a href="https://apps.apple.com/us/app/super-student/id1614354792" target="_blank" className='pe-2' >
                  <img src={`${process.env.PUBLIC_URL}/img/logo_app_store.png`} className="img-fluid w-25" alt="app-download-apple-store" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=io.niec.superstudent&hl=en&gl=US" target="_blank">
                  <img src={`${process.env.PUBLIC_URL}/img/logo_app_google.png`} className="img-fluid w-25" alt="app-download-play-store" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          {data.office.body.map((item, id) => (
            <div key={id} className='col-lg-3 d-flex'>
              <a href={item.map} target='_blank' rel='noopener noreferrer'>
                <h6>{item.city}</h6>
                <p>{item.address}</p>
              </a>
            </div>
          ))}
        </div>
        <div className='text-center mt-5'>
          © {year} NIEC Indonesia. All Rights Reserved. CV Naresy Indonesia
        </div>
      </footer>
    </section>
  )
}

export default Footer